import axios from 'axios';
import { map } from 'lodash';

const axiosInstanceIbge = axios.create({
  baseURL: process.env.BASE_URL_IBGE,
});

export const DataServiceIbge = {
  getUf: () =>
    axiosInstanceIbge
      .get('/localidades/estados')
      .then(res => {
        return map(res.data, item => {
          return {
            value: item.id,
            label: item.sigla,
          };
        });
      })
      .catch(err => console.error(err)),

  getCity: (uf: number) =>
    axiosInstanceIbge
      .get(`/localidades/estados/${uf}/municipios`)
      .then(res => {
        return map(res.data, item => {
          return {
            value: item.id,
            label: item.nome,
          };
        });
      })
      .catch(err => console.error(err)),
};
